export class OrderItemArray {
    itemNo: string;
    quantity: number;
}
